module.exports = __webpack_public_path__ + "static/img/sino.e20b266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/sino.jpg
// module id = qbIl
// module chunks = 1